<abp-card class="zn-crud-page">
  <abp-card-body>
    <app-crud-page
      #crudPage
      [tableName]="config.localizationKey"
      [permission]="config.permission"
      [fields]="fields"
      [dataset]="dataset()"
      [loading]="loading()"
      [loadData]="loadData"
      [actions]="actions"
      [exportInProgress]="exporting()"
      (exportToExcelRecord)="exportToExcel()"
      (selectedItemsChange)="onRowSelection($event)"
      [extraTableOptions]="tableOptions"
      [hideCreateButton]="true"
      [disableEdit]="true"
      [disableEditInline]="true"
      [disableCanDelete]="true"
      [disableDuplicate]="true"
    ></app-crud-page>
  </abp-card-body>
</abp-card>
